import cn from 'classnames';
import React, { useCallback } from 'react';

import setDesignColorSpaceOperation from 'editor/src/store/design/operation/setDesignColorSpaceOperation';
import getDesignColorSpace from 'editor/src/store/design/selector/getDesignColorSpace';
import { ColorSpace } from 'editor/src/store/design/types';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import styles from './index.module.scss';

function ColorSpaceToggle() {
  const dispatch = useDispatch();
  const colorSpace = useSelector(getDesignColorSpace) ?? ColorSpace.sRGB;

  const onSelectSRGB = useCallback(() => {
    if (colorSpace !== ColorSpace.sRGB) {
      dispatch(setDesignColorSpaceOperation(ColorSpace.sRGB));
    }
  }, [dispatch, colorSpace]);

  const onSelectCMYK = useCallback(() => {
    if (colorSpace !== ColorSpace.CMYK) {
      dispatch(setDesignColorSpaceOperation(ColorSpace.CMYK));
    }
  }, [dispatch, colorSpace]);

  return (
    <div className={cn(styles.container, 'cy-color-space-toggle')}>
      <button
        type="button"
        className={cn(styles.button, { [styles.active]: colorSpace === ColorSpace.sRGB }, 'cy-color-space-toggle-srgb')}
        onClick={onSelectSRGB}
      >
        sRGB
      </button>
      <button
        type="button"
        className={cn(styles.button, { [styles.active]: colorSpace === ColorSpace.CMYK }, 'cy-color-space-toggle-cmyk')}
        onClick={onSelectCMYK}
      >
        CMYK
      </button>
    </div>
  );
}

export default React.memo(ColorSpaceToggle);
